/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  PostV2SharedUrlSimulationsSimulationStepsChatByPrototypeIdAndSimulationIdAndStepIdParams,
  GetV2SharedUrlSimulationsByPrototypeIdParams,
  GetV2SharedUrlSimulationsTokenByPrototypeIdParams,
  GetV2SharedUrlSimulationsSummaryFullByPrototypeIdParams,
  GetV2SharedUrlSimulationsSubscriptionInfoByPrototypeIdParams,
  GetV2SharedUrlSimulationsSimulationByPrototypeIdAndSimulationIdParams,
  GetV2SharedUrlSimulationsSimulationStepsByPrototypeIdAndSimulationIdParams,
  GetV2SharedUrlSimulationsSimulationStepsConversationByPrototypeIdAndSimulationIdAndStepIdParams,
  GetV2SharedUrlSimulationsSimulationPersonaByPrototypeIdAndSimulationIdParams,
  GetV2SharedUrlSimulationsRunningByPrototypeIdParams,
  GetV2SharedUrlSimulationsInfoByPrototypeIdParams,
  GetV2SharedUrlSimulationsExtendedByPrototypeIdAndReviewIdParams,
  PostV2SharedUrlSimulationsSimulationStepsChatByPrototypeIdAndSimulationIdAndStepIdBody,
  PostV2SharedUrlSimulationsSimulationStepsChatByPrototypeIdAndSimulationIdAndStepIdResponse,
  GetV2SharedUrlSimulationsByPrototypeIdResponse,
  GetV2SharedUrlSimulationsTokenByPrototypeIdResponse,
  GetV2SharedUrlSimulationsSummaryFullByPrototypeIdResponse,
  GetV2SharedUrlSimulationsSubscriptionInfoByPrototypeIdResponse,
  GetV2SharedUrlSimulationsSimulationByPrototypeIdAndSimulationIdResponse,
  GetV2SharedUrlSimulationsSimulationStepsByPrototypeIdAndSimulationIdResponse,
  GetV2SharedUrlSimulationsSimulationStepsConversationByPrototypeIdAndSimulationIdAndStepIdResponse,
  GetV2SharedUrlSimulationsSimulationPersonaByPrototypeIdAndSimulationIdResponse,
  GetV2SharedUrlSimulationsRunningByPrototypeIdResponse,
  GetV2SharedUrlSimulationsInfoByPrototypeIdResponse,
  GetV2SharedUrlSimulationsExtendedByPrototypeIdAndReviewIdResponse,
} from '../types';

export class SharedURLSimulations extends Controller {
  async postV2SharedUrlSimulationsSimulationStepsChatByPrototypeIdAndSimulationIdAndStepId<
    T extends PostV2SharedUrlSimulationsSimulationStepsChatByPrototypeIdAndSimulationIdAndStepIdResponse,
    D,
    C extends PostV2SharedUrlSimulationsSimulationStepsChatByPrototypeIdAndSimulationIdAndStepIdBody
  >(
    body: C,
    {
      prototypeId,
      simulationId,
      stepId,
    }: PostV2SharedUrlSimulationsSimulationStepsChatByPrototypeIdAndSimulationIdAndStepIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/shared/url-simulations/${prototypeId}/simulation/${simulationId}/steps/${stepId}/chat`,
      body,
      axiosConfig
    );
  }

  async getV2SharedUrlSimulationsByPrototypeId<
    T extends GetV2SharedUrlSimulationsByPrototypeIdResponse,
    D,
    C
  >(
    { prototypeId }: GetV2SharedUrlSimulationsByPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/shared/url-simulations/${prototypeId}`,
      axiosConfig
    );
  }

  async getV2SharedUrlSimulationsTokenByPrototypeId<
    T extends GetV2SharedUrlSimulationsTokenByPrototypeIdResponse,
    D,
    C
  >(
    { prototypeId }: GetV2SharedUrlSimulationsTokenByPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/shared/url-simulations/${prototypeId}/token`,
      axiosConfig
    );
  }

  async getV2SharedUrlSimulationsSummaryFullByPrototypeId<
    T extends GetV2SharedUrlSimulationsSummaryFullByPrototypeIdResponse,
    D,
    C
  >(
    { prototypeId }: GetV2SharedUrlSimulationsSummaryFullByPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/shared/url-simulations/${prototypeId}/summary/full`,
      axiosConfig
    );
  }

  async getV2SharedUrlSimulationsSubscriptionInfoByPrototypeId<
    T extends GetV2SharedUrlSimulationsSubscriptionInfoByPrototypeIdResponse,
    D,
    C
  >(
    {
      prototypeId,
    }: GetV2SharedUrlSimulationsSubscriptionInfoByPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/shared/url-simulations/${prototypeId}/subscription-info`,
      axiosConfig
    );
  }

  async getV2SharedUrlSimulationsSimulationByPrototypeIdAndSimulationId<
    T extends GetV2SharedUrlSimulationsSimulationByPrototypeIdAndSimulationIdResponse,
    D,
    C
  >(
    {
      prototypeId,
      simulationId,
    }: GetV2SharedUrlSimulationsSimulationByPrototypeIdAndSimulationIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/shared/url-simulations/${prototypeId}/simulation/${simulationId}`,
      axiosConfig
    );
  }

  async getV2SharedUrlSimulationsSimulationStepsByPrototypeIdAndSimulationId<
    T extends GetV2SharedUrlSimulationsSimulationStepsByPrototypeIdAndSimulationIdResponse,
    D,
    C
  >(
    {
      prototypeId,
      simulationId,
    }: GetV2SharedUrlSimulationsSimulationStepsByPrototypeIdAndSimulationIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/shared/url-simulations/${prototypeId}/simulation/${simulationId}/steps`,
      axiosConfig
    );
  }

  async getV2SharedUrlSimulationsSimulationStepsConversationByPrototypeIdAndSimulationIdAndStepId<
    T extends GetV2SharedUrlSimulationsSimulationStepsConversationByPrototypeIdAndSimulationIdAndStepIdResponse,
    D,
    C
  >(
    {
      prototypeId,
      simulationId,
      stepId,
    }: GetV2SharedUrlSimulationsSimulationStepsConversationByPrototypeIdAndSimulationIdAndStepIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/shared/url-simulations/${prototypeId}/simulation/${simulationId}/steps/${stepId}/conversation`,
      axiosConfig
    );
  }

  async getV2SharedUrlSimulationsSimulationPersonaByPrototypeIdAndSimulationId<
    T extends GetV2SharedUrlSimulationsSimulationPersonaByPrototypeIdAndSimulationIdResponse,
    D,
    C
  >(
    {
      prototypeId,
      simulationId,
    }: GetV2SharedUrlSimulationsSimulationPersonaByPrototypeIdAndSimulationIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/shared/url-simulations/${prototypeId}/simulation/${simulationId}/persona`,
      axiosConfig
    );
  }

  async getV2SharedUrlSimulationsRunningByPrototypeId<
    T extends GetV2SharedUrlSimulationsRunningByPrototypeIdResponse,
    D,
    C
  >(
    { prototypeId }: GetV2SharedUrlSimulationsRunningByPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/shared/url-simulations/${prototypeId}/running`,
      axiosConfig
    );
  }

  async getV2SharedUrlSimulationsInfoByPrototypeId<
    T extends GetV2SharedUrlSimulationsInfoByPrototypeIdResponse,
    D,
    C
  >(
    { prototypeId }: GetV2SharedUrlSimulationsInfoByPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/shared/url-simulations/${prototypeId}/info`,
      axiosConfig
    );
  }

  async getV2SharedUrlSimulationsExtendedByPrototypeIdAndReviewId<
    T extends GetV2SharedUrlSimulationsExtendedByPrototypeIdAndReviewIdResponse,
    D,
    C
  >(
    {
      prototypeId,
      reviewId,
    }: GetV2SharedUrlSimulationsExtendedByPrototypeIdAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/shared/url-simulations/${prototypeId}/extended/${reviewId}`,
      axiosConfig
    );
  }
}
